// @flow

import { type State } from './reducers';

type GlobalState = {
  siteSettings: State,
};

const getReducer = (state: GlobalState): State => {
  const { siteSettings } = state;
  if (!siteSettings) {
    throw new Error('Missing siteSettings store.');
  }
  return siteSettings;
};

type CookieNotification = $PropertyType<State, 'cookie_notification'>;
export const getCookieNotification = (state: GlobalState): CookieNotification => (
  getReducer(state).cookie_notification
);

type GoogleSiteVerification = $PropertyType<State, 'google_site_verification'>;
export const getGoogleSiteVerification = (state: GlobalState): GoogleSiteVerification => (
  getReducer(state).google_site_verification
);

type GtmCode = $PropertyType<State, 'gtm_code'>;
export const getGtmCode = (state: GlobalState): GtmCode => (
  getReducer(state).gtm_code
);

type MainMenuMoreLabel = $PropertyType<State, 'main_menu_more_label'>;
export const getMainMenuMoreLabel = (state: GlobalState): MainMenuMoreLabel => (
  getReducer(state).main_menu_more_label
);

type MyLabel = $PropertyType<State, 'my_label'>;
export const getMyLabel = (state: GlobalState): MyLabel => (
  getReducer(state).my_label
);

type MyUrl = $PropertyType<State, 'my_url'>;
export const getMyUrl = (state: GlobalState): MyUrl => (
  getReducer(state).my_url
);

type Logo = $PropertyType<State, 'logo'>;
export const getLogo = (state: GlobalState): Logo => (
  getReducer(state).logo
);

type ThuiswinkelLogo = $PropertyType<State, 'show_thuiswinkel_logo'>;
export const getIsThuiswinkelLogoVisible = (state: GlobalState): ThuiswinkelLogo => (
  getReducer(state).show_thuiswinkel_logo
);

type Scripts = $PropertyType<State, 'scripts'>;
export const getScripts = (state: GlobalState): Scripts => {
  const { scripts } = getReducer(state);
  if (!scripts) {
    return [];
  }

  return getReducer(state).scripts.map(script => script);
};

type Favicons = $PropertyType<State, 'favicons'>;
export const getFavicons = (state: GlobalState): Favicons => (
  getReducer(state).favicons || null
);

export const getHasVbmrEnabled = (state: GlobalState): boolean => (
  getReducer(state).vbmr_enabled
);

export const getTouchMenuButtonText = (state: GlobalState): string => (
  getReducer(state).touch_menu_button_text
);

export const getTouchMenuTitleText = (state: GlobalState): string => (
  getReducer(state).touch_menu_title_text
);

export const getTouchMenuBackButtonText = (state: GlobalState): string => (
  getReducer(state).touch_menu_back_button_text
);

export default getReducer;
